[
  {
    "id": 2,
    "name": "whisper",
    "type": "stt",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/1/ai/%7Bproduct_id%7D/openai/audio/transcriptions",
    "description": "Whisper V3",
    "info_status": "ready",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/whisper.svg",
    "last_updated_at": "2024-07-01",
    "max_token_input": null,
    "version": "3.0",
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 8,
    "name": "photomaker",
    "type": "image",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/1/ai/%7Bproduct_id%7D/images/generations/photo_maker",
    "description": "Photomaker V2",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/photomaker.svg",
    "last_updated_at": "2024-07-15",
    "max_token_input": null,
    "version": "2.0",
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 10,
    "name": "flux",
    "type": "image",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/1/ai/%7Bproduct_id%7D/openai/images/generations",
    "description": "Flux schnell",
    "info_status": "ready",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/flux.svg",
    "last_updated_at": "2024-10-01",
    "max_token_input": null,
    "version": "0.1",
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 12,
    "name": "bge_multilingual_gemma2",
    "type": "embedding",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/embeddings",
    "description": "Bge Multilingual Gemma2",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/bge.svg",
    "last_updated_at": "2024-12-04",
    "max_token_input": 8000,
    "version": "1.0",
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 13,
    "name": "mini_lm_l12_v2",
    "type": "embedding",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/embeddings",
    "description": "All MiniLM L12 v2",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/minilm.svg",
    "last_updated_at": "2024-12-04",
    "max_token_input": 128,
    "version": "2.0",
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 21,
    "name": "Qwen/Qwen3-Embedding-8B",
    "type": "embedding",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/embeddings",
    "description": "Qwen/Qwen3-Embedding-8B",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/qwen.svg",
    "last_updated_at": "2025-11-24",
    "max_token_input": 8192,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 23,
    "name": "BAAI/bge-reranker-v2-m3",
    "type": "reranker",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/cohere/v2/rerank",
    "description": "BAAI/bge-reranker-v2-m3",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/bge.svg",
    "last_updated_at": "2025-12-12",
    "max_token_input": null,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 24,
    "name": "Qwen/Qwen3-Reranker-0.6B",
    "type": "reranker",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/cohere/v2/rerank",
    "description": "Qwen/Qwen3-Reranker-0.6B",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/qwen.svg",
    "last_updated_at": "2025-12-12",
    "max_token_input": null,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 27,
    "name": "mistralai/Ministral-3-14B-Instruct-2512",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "mistralai/Ministral-3-14B-Instruct-2512",
    "info_status": "ready",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/mixtral.svg",
    "last_updated_at": "2026-02-02",
    "max_token_input": 100000,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 30,
    "name": "Qwen/Qwen3.5-122B-A10B-FP8",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "Qwen/Qwen3.5-122B-A10B-FP8",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/qwen.svg",
    "last_updated_at": null,
    "max_token_input": 200000,
    "version": null,
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 31,
    "name": "google/gemma-4-31B-it",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "google/gemma-4-31B-it",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/google.svg",
    "last_updated_at": null,
    "max_token_input": 100000,
    "version": null,
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 32,
    "name": "moonshotai/Kimi-K2.6",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "moonshotai/Kimi-K2.6",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/moonshotai.svg",
    "last_updated_at": null,
    "max_token_input": 256000,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 33,
    "name": "nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B-FP8",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B-FP8",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/nvidia.svg",
    "last_updated_at": null,
    "max_token_input": 1000000,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 34,
    "name": "mistralai/Mistral-Small-4-119B-2603",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "mistralai/Mistral-Small-4-119B-2603",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/mistralai.svg",
    "last_updated_at": null,
    "max_token_input": 256000,
    "version": null,
    "meta": {
      "is_beta": false,
      "is_coder": false
    }
  },
  {
    "id": 35,
    "name": "Qwen/Qwen3.5-397B-A17B-FP8",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "Qwen/Qwen3.5-397B-A17B-FP8",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/qwen.svg",
    "last_updated_at": null,
    "max_token_input": 200000,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  },
  {
    "id": 37,
    "name": "swiss-ai/Apertus-v1.5-70B",
    "type": "llm",
    "documentation_link": "https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions",
    "description": "swiss-ai/Apertus-v1.5-70B",
    "info_status": "coming_soon",
    "logo_url": "https://storage4.infomaniak.com/ai-tools/public/logos/apertus.svg",
    "last_updated_at": null,
    "max_token_input": 100000,
    "version": null,
    "meta": {
      "is_beta": true,
      "is_coder": false
    }
  }
]
